<template>
  <div>
    <van-nav-bar
      title="确认订单"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="center">
        <div v-if="realStatus">
          <div
            v-if="isShow"
            @click="showAddress"
            style="
              display: flex;
              margin: 0.6rem 0.75rem;
              height: 4.5rem;
              padding: 0.95rem 0.5rem 0.9rem 0.6rem;
              background-color: #ffffff;
              border-radius: 0.7rem;
            "
          >
            <div
              class="icon"
              style="
                margin-top: 0.3rem;
                margin-right: 0.6rem;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 2.05rem;
                height: 2.05rem;
                border-radius: 50%;
                background-color: #f3f2f2;
              "
            >
              <van-icon
                name="location"
                color="rgba(158, 17, 4, .66)"
                size="1.113rem"
              />
            </div>
            <div
              class="txt"
              style="
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
              "
            >
              <p
                style="
                  font-weight: bold;
                  color: rgba(0, 0, 0, 1);
                  font-size: 0.7rem;
                "
              >
                {{ defaultAddressList.name }}
              </p>
              <p style="font-size: 0.6rem; color: rgba(101, 101, 101, 1)">
                {{ defaultAddressList.address }}
              </p>
              <p style="font-size: 0.6rem; color: rgba(101, 101, 101, 1)">
                {{ defaultAddressList.detailAddress }}
              </p>
            </div>
            <div
              class="point"
              style="margin-right: 0.3rem; margin-top: 0.95rem"
            >
              <van-icon name="arrow" color="#9E9E9E" size=" .7995rem" />
            </div>
          </div>

          <van-cell
            v-else
            class="address-body-cell"
            title="手动添加收货地址"
            icon="location"
            is-link
            @click="showAddress"
          >
          </van-cell>
        </div>
        <div v-if="virtualStatus">
          <div
            v-if="roleDisplay"
            @click="roleShow = true"
            style="
              display: flex;
              margin: 0.6rem 0.75rem;
              height: 4.5rem;
              padding: 0.95rem 0.5rem 0.9rem 0.6rem;
              background-color: #ffffff;
              border-radius: 0.7rem;
            "
          >
            <div
              class="icon"
              style="
                margin-top: 0.3rem;
                margin-right: 0.6rem;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 2.05rem;
                height: 2.05rem;
                border-radius: 50%;
                background-color: #f3f2f2;
              "
            >
              <van-icon
                name="manager"
                color="rgba(158, 17, 4, .66)"
                size="1.113rem"
              />
            </div>
            <div
              class="txt"
              style="
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
              "
            >
              <p
                style="
                  font-weight: bold;
                  color: rgba(0, 0, 0, 1);
                  font-size: 0.7rem;
                "
              >
                {{ currentRole.name }}
              </p>
              <p style="font-size: 0.6rem; color: rgba(101, 101, 101, 1)">
                {{ currentRole.address }}
              </p>
            </div>
            <div
              class="point"
              style="margin-right: 0.3rem; margin-top: 0.95rem"
            >
              <van-icon name="arrow" color="#9E9E9E" size=" .7995rem" />
            </div>
          </div>
          <van-cell
            v-else
            class="address-body-cell"
            title="手动添加角色"
            icon="manager"
            is-link
            @click="showRole"
          >
          </van-cell>
        </div>
        <div class="proBox">
          <div class="goods-card">
            <div class="left-img">
              <img :src="goods_img" alt="" />
            </div>
            <div class="right-txt">
              <p class="fir">
                <span>{{ name }}</span>
                <span>￥{{ price }}</span>
              </p>
              <p class="sec">
                <span>{{ gift_name }}</span>
                <span>x{{ number }}</span>
              </p>
            </div>
          </div>
          <div v-show="yunStatus" class="yunState">
            <span>使用方式</span>
            <label>
              <input
                class="input-radio"
                type="radio"
                v-model="selectedOption"
                value="1"
              />
              新增云手机
            </label>
            <label style="margin-right: 2.05rem" @click="yunDeviceShow = true">
              <input
                class="input-radio"
                type="radio"
                v-model="selectedOption"
                value="2"
              />
              云手机续时
            </label>
          </div>
        </div>
        <div
          class="yun-combine"
          v-if="yunStatus && number > 1 && selectedOption == '1'"
        >
          <p class="question">您共计购买了 {{ number }} 个商品，请问您需要</p>
          <van-radio-group v-model="yunmessage" class="answer">
            <van-radio name="1" icon-size=".7rem">
              <p class="one">合并 1 台云手机</p>
            </van-radio>
            <van-radio name="2" icon-size=".7rem">
              <p class="two">分成 {{ number }} 台云手机</p>
            </van-radio>
          </van-radio-group>
        </div>
        <div class="yun-device" v-if="yunDevice">
          <div class="device-img">
            <img width="100%" height="100%" src="" alt="" />
          </div>
          <div class="device-info">
            <div class="title">{{ yunDevice.name }}</div>
            <div class="info">
              <p class="t1">ID：{{ yunDevice.id }}</p>
              <p class="t2">剩余 : {{ yunDevice.remainder }}</p>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>

    <van-popup
      closeable
      v-model="addressShow"
      round
      :close-on-click-overlay="false"
      @close="onCloseHandle"
      position="bottom"
      style="max-height: 70%"
    >
      <div v-if="delPop" class="bg-transparent"></div>
      <div class="tc" v-if="delPop">
        <div class="title">确定要删除该地址吗</div>
        <div class="tc-btn">
          <button class="qx" @click="delPop = false">取消</button>
          <button class="sc" @click="confirmHandle">删除</button>
        </div>
      </div>
      <div
        style="
          position: sticky;
          top: 0;
          background-color: #f3f2f2;
          z-index: 100;
          padding-top: 1.05rem;
        "
      >
        <p style="font-size: 0.8rem; color: #000000; text-align: center">
          收货地址
          <van-icon
            style="position: absolute; top: 0.8rem; right: 0.8rem"
            @click="onCloseAddressShow"
            size="1.1rem"
            color="#000000"
            name="cross"
          />
        </p>
        <div v-if="!editToggle" class="common-addresses">
          <p>常用地址</p>
          <p class="manage" @click="onToggle"><van-icon name="edit" />管理</p>
          <p @click="$router.push({ name: 'shop.address' })">
            <van-icon name="plus" />添加
          </p>
        </div>
        <div v-else class="common-addresses">
          <p>常用地址</p>
          <p class="manage" @click="onToggle"><van-icon name="edit" />完成</p>
          <p @click="$router.push({ name: 'shop.address' })">
            <van-icon name="plus" />添加
          </p>
        </div>
      </div>

      <van-address-list
        v-model="chosenAddressId"
        :list="list"
        default-tag-text="默认"
        @add="onAdd"
        @select="selected"
        add-button-text="确认"
      >
        <template #item-bottom="{ id }">
          <div
            class="icon"
            style="
              margin-top: 0.3rem;
              margin-right: 0.6rem;
              display: flex;
              position: absolute;
              top: 0.6rem;
              justify-content: center;
              align-items: center;
              width: 2.05rem;
              height: 2.05rem;
              border-radius: 50%;
              background-color: #f3f2f2;
            "
          >
            <van-icon
              name="location"
              color="rgba(158, 17, 4, .66)"
              size="1.113rem"
            />
          </div>
          <div v-if="editToggle">
            <div
              style="
                text-align: right;
                padding-top: 0.75rem;
                margin-right: 0.5rem;
                border-top: 0.05rem solid #f2f2f2;
                color: #9e9e9e;
                font-size: 0.6rem;
                display: flex;
                justify-content: space-between;
              "
            >
              <div @click="preventSpread">
                <label
                  style="
                    margin-left: 3rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 0.25rem;
                  "
                >
                  <input
                    style="display: none"
                    type="radio"
                    v-model="defaultId"
                    :value="id"
                  />
                  <span class="radio-dot" :class="{ checked: defaultId == id }">
                    <i
                      style="
                        display: block;
                        width: 2.4rem;
                        height: 0.75rem;
                        line-height: 0.75rem;
                        margin-left: 0.9rem;
                        font-style: normal;
                      "
                      >默认地址</i
                    >
                  </span>
                </label>
              </div>
              <p @click.stop="delHandle(id)">删除</p>
            </div>
          </div>
        </template>
      </van-address-list>
    </van-popup>

    <van-popup
      v-model="roleShow"
      closeable
      round
      :close-on-click-overlay="false"
      position="bottom"
      style="max-height: 70%"
    >
      <div
        style="
          position: sticky;
          top: 0;
          background-color: #f3f2f2;
          z-index: 100;
          padding-top: 1.05rem;
        "
      >
        <p style="font-size: 0.8rem; color: #000000; text-align: center">
          角色信息
          <van-icon
            style="position: absolute; top: 0.8rem; right: 0.8rem"
            @click="roleShow = false"
            size="1.1rem"
            color="#000000"
            name="cross"
          />
        </p>
        <div class="common-addresses">
          <p>角色选择</p>
          <!-- <p class="manage"><van-icon name="coupon-o" />管理</p>
                <p>
                  <van-icon name="plus" />添加
                </p> -->
        </div>
      </div>
      <van-address-list
        v-model="roleId"
        :list="roleList"
        default-tag-text="默认"
        @add="onRoleAdd"
        @select="RoleSelected"
        add-button-text="确认"
      >
        <template #item-bottom>
          <div
            class="icon"
            style="
              margin-top: 0.3rem;
              margin-right: 0.6rem;
              display: flex;
              position: absolute;
              top: 0.6rem;
              justify-content: center;
              align-items: center;
              width: 2.05rem;
              height: 2.05rem;
              border-radius: 50%;
              background-color: #f3f2f2;
            "
          >
            <van-icon
              name="manager"
              color="rgba(158, 17, 4, .66)"
              size="1.113rem"
            />
          </div>
        </template>
      </van-address-list>
    </van-popup>

    <van-popup
      v-model="yunDeviceShow"
      round
      position="bottom"
      :style="{ height: '62%' }"
      style="background-color: #ffffff"
    >
      <div class="dev-title">
        <p>请选择要续时的设备</p>
        <van-icon
          class="cross"
          name="cross"
          color="#000000"
          size="16px"
          @click="yunDeviceShow = false"
        />
      </div>
      <div class="dev-box">
        <label v-for="(item, i) in deviceList" :key="i">
          <div
            class="yun-dev"
            :class="{
              active: popSelectedDev ? popSelectedDev.id == item.id : false,
            }"
          >
            <div class="dev-img">
              <img width="100%" height="100%" src="" alt="" />
            </div>
            <div class="dev-info">
              <div class="title">
                <p class="name">{{ item.name }}</p>
                <input
                  class="input-radio"
                  type="radio"
                  :value="item"
                  v-model="popSelectedDev"
                />
              </div>
              <div class="info">
                <p class="id">ID：{{ item.id }}</p>
                <p class="time">剩余 : {{ item.remainder }}</p>
              </div>
            </div>
          </div>
        </label>
      </div>
      <div class="confirm-btn" @click="makeSure">确定</div>
    </van-popup>

    <div class="btn">
      <div style="text-align: right; flex: 1; margin-right: 1.35rem">
        <span style="margin-right: 0.4rem">需付款</span>￥
        <span
          style="
            font-size: 1.1rem;
            color: rgba(103, 0, 0, 1);
            font-weight: bold;
          "
          >{{ parseInt(totalPrice) }}.</span
        >
        <span
          style="
            font-size: 0.75rem;
            color: rgba(103, 0, 0, 1);
            font-weight: bold;
          "
        >
          {{ totalPrice % 1 == 0 ? "00" : totalPrice.toString().split(".")[1] }}
        </span>
      </div>
      <div class="right">
        <span style="color: rgba(214, 27, 10, 1)"> 免运费 </span>
        <button
          class="buy"
          @click="submitHandle"
          style="
            border: none;
            width: 5.5rem;
            height: 1.7rem;
            background-color: rgba(103, 0, 0, 1);
            color: rgba(255, 255, 255, 1);
            line-height: 1.7rem;
            border-radius: 1.25rem;
          "
        >
          提交订单
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
import api from "../Api";
export default {
  mixins: [api],
  data() {
    return {
      //要选择修改的默认地址id
      defaultId: "",
      checked: true,
      isShow: false,
      roleDisplay: false,
      addressShow: false,
      editToggle: false,
      roleShow: false,
      selectedOption: "1",
      deleteId: "",
      //初始选择的角色id
      roleId: "",
      roleList: [],
      roleSelect: {},
      currentRole: {},
      //选择地址数据
      chosenAddressId: null,
      defaultAddressList: {},
      list: [],
      selectList: {},
      disabledList: [],
      goods_img: "",
      gift_name: "",
      name: "",
      price: "",
      number: "",
      totalPrice: 0,
      space: " ",
      //是否真实地址
      realStatus: false,
      //是否虚拟地址
      virtualStatus: false,
      //是否云产品
      yunStatus: false,
      //聚合项目appid
      juheAppId: "",
      //我的云手机列表
      deviceList: [],
      //选中的选项值
      popSelectedDev: null,
      //当前选择的云手机
      yunDevice: null,
      yunDeviceShow: false,
      delPop: false,
      yunmessage: "1",
    };
  },
  watch: {
    defaultId(newValue) {
      //此处可以获取到最新选择的地址id，根据id设置默认地址
      this.chosenAddressId = newValue;
      if (this.defaultId) {
        this.$Ajax("/shop/default-address", { addressId: newValue }).then(
          (res) => {
            this.getUserAddress();
            this.selectList = null;
          }
        );
      }
    },
    selectedOption(option) {
      if (option == 1) {
        this.yunDevice = null;
      }
    },
  },
  created() {
    //此数据只为完成页面而设置，后面根据数据重新写
    this.deviceList = [
      {
        name: "测试设备1",
        id: "8888",
        remainder: "2天12时15秒",
      },
      {
        name: "测试设备2",
        id: "9999",
        remainder: "3天11时36秒",
      },
    ];
  },
  mounted() {
    //获取购买商品信息
    this.$Ajax("/shop/new-goods-info", {
      goodsId: this.$route.query.id,
      itemIds: this.$route.query.skuId,
    }).then((res) => {
      this.totalPrice = res.data.data.allPrice;
      this.goods_img = res.data.data.goodsGroupItem[0].img;
      this.name = res.data.data.goodsInfo.goods_name;
      this.price = res.data.data.goodsGroupItem[0].price;
      this.number = this.$route.query.num;
      this.gift_name = res.data.data.goodsGroupItem[0].gift_name;
      this.realStatus = res.data.data.realStatus;
      this.virtualStatus = res.data.data.virtualStatus;
      this.yunStatus = res.data.data.yunStatus;
      this.juheAppId = res.data.data.juheAppId;

      this.getUserAddress();
    });
    // 数据模板例
    // this.roleList = [
    //   {
    //     id: "1",
    //     name: "校长哈尼",
    //     tel: "",
    //     address: "永恒岛之彩虹世界 安卓&IOS（七龙专区） S403.乘天乱舞",
    //   },
    // ];
  },
  methods: {
    showRole() {
      this.getRoleinfo();
      this.roleShow = true;
    },
    //获取角色信息
    getRoleinfo() {
      this.$Ajax("/shop/get-user-role-list", {
        juheAppId: this.juheAppId,
        page: 1,
        limit: 10,
      }).then((res) => {
        // this.roleId = res.data.list[0].id;
        this.roleList = res.data.list.map((item) => {
          return {
            id: item.id,
            name: item.role_name,
            tel: "",
            address:
              item.app_name +
              "　" +
              item.solution_name +
              "　" +
              item.server_name,
            // isDefault: true,
          };
        });
        //是否直接显示一个角色信息
        // if (this.roleList[0].id) {
        //   this.currentRole = this.roleList[0];
        //   this.roleDisplay = true;
        // }
      });
    },
    onCloseHandle() {
      this.editToggle = false;
    },
    onCloseAddressShow() {
      this.addressShow = false;
      this.chosenAddressId = this.defaultAddressList.id;
    },
    onToggle() {
      this.editToggle = !this.editToggle;
    },
    preventSpread(event) {
      event.stopPropagation();
    },
    //删除收货地址
    deleteAddress(id) {
      this.$Ajax("/shop/delete-address", { addressId: id }).then((res) => {
        this.getUserAddress();
      });
    },
    delHandle(id) {
      this.delPop = true;
      this.deleteId = id;
    },
    confirmHandle() {
      this.deleteAddress(this.deleteId);
      this.selectList = null;
      this.delPop = false;
    },
    selected(v) {
      //选中的地址
      this.selectList = v;
    },
    getUserAddress() {
      //获取用户收货地址
      this.$Ajax("shop/get-user-address", {}).then((res) => {
        this.list =
          res.data == null
            ? []
            : res.data.map((item) => {
                return {
                  id: item.id,
                  name: item.user_name,
                  tel: item.phone,
                  detailAddress: item.detail_address,
                  address: item.street_name
                    ? item.province_name +
                      this.space +
                      item.city_name +
                      this.space +
                      item.area_name +
                      this.space +
                      item.street_name
                    : item.province_name +
                      this.space +
                      item.city_name +
                      this.space +
                      item.area_name,
                  isDefault: item.is_default,
                };
              });
        //默认选中的id
        this.chosenAddressId =
          this.list.filter((item) => {
            return item.isDefault;
          }).length == 0
            ? null
            : this.list.filter((item) => {
                return item.isDefault;
              })[0].id;
        //默认收货地址
        this.defaultId =
          this.list.filter((item) => {
            return item.isDefault;
          }).length == 0
            ? null
            : this.list.filter((item) => {
                return item.isDefault;
              })[0].id;
        if (this.chosenAddressId) {
          this.defaultAddressList = this.list.filter((item) => {
            return item.isDefault;
          })[0];
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      });
    },
    showAddress() {
      this.addressShow = true;
    },
    onAdd() {
      // 当前选择的地址
      if (this.selectList) {
        this.isShow = true;
        this.defaultAddressList = this.selectList;
      }
      if (this.chosenAddressId == null) {
        this.isShow = false;
      }
      this.addressShow = false;
    },
    submitHandle() {
      this.makeOrder();
    },
    onRoleAdd() {
      //角色弹出层点击确定按钮时触发
      this.roleShow = false;
      if (this.roleSelect.id) {
        this.roleDisplay = true;
        this.currentRole = this.roleSelect;
      }
    },
    RoleSelected(v) {
      //切换选中的角色时触发
      this.roleSelect = v;
    },

    //云手机弹出层确认操作
    makeSure() {
      this.yunDevice = this.popSelectedDev;
      this.yunDeviceShow = false;
    },
    //下单接口
    makeOrder() {
      var params = {
        goodsId: this.$route.query.id,
        itemIds: this.$route.query.skuId,
        num: this.$route.query.num,
      };
      if (this.realStatus) {
        if (this.chosenAddressId == null) {
          return this.$toast("请填写收货地址!");
        } else {
          params.addressId = this.chosenAddressId;
        }
      }
      if (this.virtualStatus) {
        if (this.roleId == "") {
          return this.$toast("请选择角色!");
        } else {
          params.fictitiousId = this.roleId;
        }
      }
      this.$Ajax("/shop/new-make-order", params).then((res) => {
        if (res.code == 200) {
          this.$router.push({
            name: "shop.payment",
            query: {
              order_num: res.data.order_num,
            },
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.van-cell__left-icon {
  margin-top: 0.3rem;
  margin-right: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.05rem;
  height: 2.05rem;
  border-radius: 50%;
  background-color: #f3f2f2;
  font-size: 1.113rem;
  color: rgba(158, 17, 4, 0.66);
}

.van-address-item {
  position: relative;

  .van-address-item__value {
    padding-left: 2.05rem;
  }

  :deep(.van-radio__label) {
    flex: 1;
  }
}

:deep(.van-address-item__name) {
  color: rgba(0, 0, 0, 1);
  font-weight: bold;
  font-size: 0.7rem;

  .van-tag--round {
    background-color: rgba(236, 215, 213, 1);
    border-radius: 0.2rem;
    color: rgba(103, 0, 0, 1);
    font-weight: normal;
    font-size: 0.6rem;
    display: inline-block;
  }
}

.van-address-item__edit {
  display: none;
}

:deep(.van-popup__close-icon) {
  color: #000000;
}

:deep(.van-radio__icon) {
  position: absolute;
  right: 0.5rem;
}

.van-popup--bottom {
  background-color: rgba(243, 242, 242, 1);

  .van-sku-stepper-stock {
    overflow: visible;
  }
}

.common-addresses {
  font-size: 0.8rem;
  color: rgba(103, 0, 0, 1);
  padding: 1.15rem 0.75rem 0;
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.85rem;
  .manage {
    margin-left: 7.7rem;
  }
}

.bg-transparent {
  position: fixed;
  z-index: 2019;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.63);
}

.tc {
  text-align: center;
  position: fixed;
  z-index: 2020;
  width: 14.7rem;
  height: 6.9rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.7rem;
  background-color: #ffffff;
  .title {
    margin-top: 1.55rem;
    margin-bottom: 1.25rem;
    font-size: 0.8rem;
    color: #000000;
    font-weight: bold;
  }
  .tc-btn {
    display: flex;
    justify-content: center;
    gap: 1rem;
    button {
      width: 4.9rem;
      height: 1.7rem;
      border-radius: 0.85rem;
      border: none;
    }
    .qx {
      border: 0.05rem #707070 solid;
      color: #9e9e9e;
    }
    .sc {
      background-color: #000000;
      color: #ffffff;
    }
  }
}

.center {
  margin-top: 2.5rem;
  padding-top: 0.2rem;
}

.btn {
  display: flex;
  box-shadow: 0 0.15rem 0.3rem 0.05rem rgba(0, 0, 0, 0.16);
  padding: 0.5rem 0.75rem 1.75rem;
  justify-content: space-between;
  width: 100%;
  height: 3.95rem;
  background-color: rgba(255, 255, 255, 1);
  position: fixed;
  bottom: 0;
}

.address-body-cell {
  width: auto;
  font-size: 0.7rem;
  color: #000000;
  height: 3.05rem;
  margin: 0 0.75rem;
  border-radius: 0.7rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.van-cell--clickable {
  margin-top: 0.6rem;
}

.van-address-item__address {
  margin-bottom: 0.65rem;
}

.van-checkbox {
  float: left;
}

.proBox {
  margin: 0.6rem 0.75rem;
  padding: 0.8rem 0.55rem 0.95rem 0.6rem;
  border-radius: 0.7rem;
  background-color: rgba(255, 255, 255, 1);

  .yunState {
    display: flex;
    justify-content: space-between;
    margin-top: 1.25rem;
  }
}

.goods-card {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left-img img {
    width: 3.85rem;
    height: 3.9rem;
    margin-right: 0.7rem;
    border-radius: 0.4rem;
  }

  .right-txt {
    flex: 1;

    .fir {
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.95rem;
      color: rgba(0, 0, 0, 1);
      font-weight: bold;
    }

    .sec {
      display: flex;
      justify-content: space-between;
      color: rgba(158, 158, 158, 1);
    }
  }
}

:deep(.van-address-list) {
  display: flex;
  flex-direction: column;
  padding: 0 0.6rem 0;
  height: auto;

  .van-radio-group {
    padding-bottom: 7.65rem;
  }

  .van-address-list__bottom {
    background-color: #f3f2f2;

    .van-address-list__add {
      margin-bottom: 1rem;
      height: 2.3rem;
      background-color: #670000;
    }
  }
}

.radio-dot {
  display: inline-block;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  margin-right: 5px;
  background-color: #e4e4e4;
  color: #9e9e9e;
}

.checked {
  background-color: #ecd7d5;
  background-image: url("../../assets/icons/ic_duihao.png");
  background-repeat: no-repeat;
  background-position: center;
  color: #670000;
}
.yun-combine {
  margin: 0.6rem 0.75rem 0;
  color: #000000;
  background-color: #ffffff;
  border-radius: 0.7rem;
  padding: 0.65rem 0.6rem 0.7rem;
  :deep(.van-radio__icon) {
    position: static;
  }
  .question {
    margin-bottom: 0.5rem;
  }
  .answer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.4rem;
    :deep(.van-icon) {
      background-color: #e4e4e4;
    }
    :deep(.van-radio__icon--checked) {
      .van-icon {
        background-color: #ecd7d5;
        color: #670000;
        border: none;
      }
    }
  }
  .one {
    color: #000000;
  }
  .two {
    color: #000000;
  }
}

.yun-device {
  height: 3.85rem;
  margin: 0.6rem 0.75rem 0;
  background-color: #ffffff;
  border-radius: 0.7rem;
  padding: 0.75rem 0.6rem;
  display: flex;

  .device-img {
    width: 2.35rem;
    height: 2.35rem;
    margin-right: 0.9rem;
    background-color: #ecd7d5;
  }

  .device-info {
    flex: 1;
    display: flex;
    flex-direction: column;

    .title {
      color: #000000;
      margin-bottom: 0.45rem;
    }

    .info {
      font-size: 0.6rem;
      display: flex;
      justify-content: space-between;

      .t1 {
        color: #9e9e9e;
      }

      .t2 {
        color: #670000;
      }
    }
  }
}

.dev-title {
  padding-top: 1.35rem;
  padding-bottom: 1.15rem;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  color: #000000;
  font-weight: bold;
  font-size: 0.8rem;
  .cross {
    position: absolute;
    right: 0.75rem;
    top: 1.35rem;
  }
}
.dev-box {
  height: 55%;
  margin-bottom: 1.35rem;
  overflow-y: scroll;
  .yun-dev {
    margin: 0 1.35rem 0.75rem;
    padding: 0.8rem 0.6rem;
    border: 0.05rem solid #f3f2f2;
    border-radius: 0.7rem;
    display: flex;
    .dev-img {
      width: 2.35rem;
      height: 2.35rem;
      margin-right: 0.5rem;
    }
    .dev-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        display: flex;
        justify-content: space-between;
        .name {
          color: #000000;
        }
      }
      .info {
        display: flex;
        justify-content: space-between;
        .id {
          color: #9e9e9e;
          font-size: 0.6rem;
        }
        .time {
          color: #670000;
          font-size: 0.6rem;
        }
      }
    }
  }
  .active {
    background-color: rgba(236, 215, 213, 0.12);
    border: 1px solid rgba(103, 0, 0, 0.12);
  }
}
.input-radio {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 0.65rem;
  height: 0.65rem;
  border-radius: 50%;
  outline: none;
  position: relative;
  cursor: pointer;
  background-color: #e4e4e4;
}
.input-radio:checked::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0.65rem;
  height: 0.65rem;
  background-color: #ecd7d5;
  background-image: url("../../assets/icons/ic_duihao.png");
  background-repeat: no-repeat;
  background-position: center;
  color: #670000;
  border-radius: 50%;
}
.confirm-btn {
  width: 16.05rem;
  height: 2.5rem;
  border-radius: 2.5rem;
  font-size: 0.8rem;
  color: #ffffff;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>
